import stores from "@/storage/stores";
import { isAppleDevice } from "../fetch/isAppleDevice";
import { jwt } from "@/event/jwt/jwt";

export function setTokenDevice(result: any): void {
    const store = stores.getStoresData();
    const storeName = store.name;

    if (isAppleDevice() && result.access_token && result.refresh_token) {
        jwt.value = result.jwt || '';
        if (storeName) {
            localStorage.setItem(`${storeName}_refresh_token`, result.refresh_token || '');
        } else {
            localStorage.setItem('refresh_token', result.refresh_token || '');
        }
    }
}